<input
    kui-input="{{ field.id }}"
    type="number"
    placeholder="{{ field.placeholder }}"
    key-number-validator
    [min]="field.min"
    [max]="field.max"
    [step]="step"
    [ngModel]="value"
    (ngModelChange)="changeNumber($event)"
    [required]="field.required"
    [disabled]="field.readonly"
    #numberField="ngModel"
    [class.border-danger]="error || (numberField.invalid && (numberField.dirty || numberField.touched))"
/>

@if (numberField.invalid && (numberField.dirty || numberField.touched)) {
    <div class="invalid-feedback d-block">
        @if (numberField.errors["required"]) {
            <div>
                {{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}
            </div>
        }
        @if (numberField.errors["min"]) {
            <div>
                {{ "FORMS.NUMBER.MIN" | translate: { field: field.title, min: field.min } }}
            </div>
        }
        @if (numberField.errors["max"]) {
            <div>
                {{ "FORMS.NUMBER.MAX" | translate: { field: field.title, max: field.max } }}
            </div>
        }
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
